<template>
  <div class="rankingList-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-40">
          <el-form ref="form" :model="allForm" label-width="92px">
            <el-form-item label="时间：">
              <el-date-picker v-model="allForm.times" placeholder="选择日期" type="month"
                              size="small" format="yyyy-MM" :clearable="false" :picker-options="pickerOptions"
                              value-format="yyyy-MM" @change="getAllRank(wholeTime = 2)"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">企业排行榜</div>
                <div class="float-right">
                  <el-select v-model="companyFrom.platform" placeholder="请选择" size="small"
                             @change="getCompanyRank()">
                    <el-option label="全平台" value="全平台" class=""></el-option>
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>
                    <!--                    <el-option label="国美在线" value="国美在线" class=""></el-option>-->
                    <!--                    <el-option label="当当网" value="当当网" class=""></el-option>-->
                    <!--                    <el-option label="亚马逊(中国)" value="亚马逊(中国)" class=""></el-option>-->
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('企业榜',companyFrom.platform)"></i>
                </div>
              </div>
              <el-table :data="companyRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="企业名称"></el-table-column>
                <el-table-column prop="area" label="工商注册地" width="118"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12" class="padding-l-30 padding-r-40">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">企业店铺榜</div>
                <div class="float-right">
                  <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"
                             @change="getCompanyShopRank()">
                    <el-option label="全平台" value="全平台" class="" checked="checked" :key="item.value1"></el-option>
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>
                    <!--                    <el-option label="国美在线" value="国美在线" class=""></el-option>-->
                    <!--                    <el-option label="当当网" value="当当网" class=""></el-option>-->
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('企业店铺榜',transactionForm.platform)"></i>
                </div>
              </div>
              <el-table :data="companyShopRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="area" label="店铺所在地" width="158"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">个人店铺榜</div>
                <div class="float-right">
                  <el-select v-model="personalShopForm.platform" placeholder="请选择" size="small"
                             @change="getPersonalShopRank()">
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('个人店铺榜',personalShopForm.platform)"></i>
                </div>
              </div>
              <el-table :data="personalShopRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="area" label="店铺所在地" width="158"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12" class="padding-l-30 padding-r-40">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">区县排行榜</div>
              </div>
              <el-table :data="cityRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center">
                </el-table-column>
                <el-table-column prop="city" label="地市" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">品牌榜</div>
                <div class="float-right">
                  <el-select v-model="brandRankForm.platform" placeholder="请选择" size="small" @change="getBrandRank()">
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>

                  </el-select>
                  <i class="el-icon-download font-18" @click="down('品牌榜',brandRankForm.platform)"></i>
                </div>
              </div>
              <el-table :data="brandRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center">
                </el-table-column>
                <el-table-column prop="name" label="品牌" align="center"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12" class="padding-l-30 padding-r-40">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">单品榜</div>
                <div class="float-right">
                  <el-select v-model="spuForm.platform" placeholder="请选择" size="small" @change="getSpuRank()">
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('单品榜',spuForm.platform)"></i>
                </div>
              </div>
              <el-table :data="spuRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="单品" :show-overflow-tooltip="true">
                  <template slot-scope="scope" >
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" width="160" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-40">
          <el-form ref="form" :model="allForm" label-width="92px">
            <el-form-item label="时间：">
              <el-date-picker v-model="allForm.times" placeholder="选择日期" type="month"
                              size="small" format="yyyy-MM" :clearable="false" :picker-options="pickerOptions"
                              value-format="yyyy-MM" @change="getAllRank(wholeTime = 2)"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">企业排行榜</div>
                <div class="float-right">
                  <el-select v-model="companyFrom.platform" placeholder="请选择" size="small"
                             @change="getCompanyRank()">
                    <el-option label="全平台" value="全平台" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>
                    <el-option label="国美在线" value="国美在线" class=""></el-option>
                    <el-option label="当当网" value="当当网" class=""></el-option>
                    <el-option label="亚马逊(中国)" value="亚马逊(中国)" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('企业榜',companyFrom.platform)"></i>
                </div>
              </div>
              <el-table :data="companyRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="企业名称"></el-table-column>
                <el-table-column prop="area" label="工商注册地" width="118"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12" class="padding-l-30 padding-r-40">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">企业店铺榜</div>
                <div class="float-right">
                  <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"
                             @change="getCompanyShopRank()">
                    <el-option label="全平台" value="全平台" class="" checked="checked" :key="item.value1"></el-option>
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>
                    <el-option label="国美在线" value="国美在线" class=""></el-option>
                    <el-option label="当当网" value="当当网" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('企业店铺榜',transactionForm.platform)"></i>
                </div>
              </div>
              <el-table :data="companyShopRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="area" label="店铺所在地" width="158"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">个人店铺榜</div>
                <div class="float-right">
                  <el-select v-model="personalShopForm.platform" placeholder="请选择" size="small"
                             @change="getPersonalShopRank()">
                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('个人店铺榜',personalShopForm.platform)"></i>
                </div>
              </div>
              <el-table :data="personalShopRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="area" label="店铺所在地" align="center" width="158"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12" class="padding-l-30 padding-r-40">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">区县排行榜</div>
              </div>
              <el-table :data="cityRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" align="center">
                </el-table-column>
                <el-table-column prop="city" label="地市" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="margin-l-30  margin-t-20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="index-header">
                <div class="float-left">品牌榜</div>
                <div class="float-right">
                  <el-select v-model="brandRankForm.platform" placeholder="请选择" size="small" @change="getBrandRank()">
                    <el-option label="京东商城" value="京东商城" class=""></el-option>
                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>
                  </el-select>
                  <i class="el-icon-download font-18" @click="down('品牌榜',brandRankForm.platform)"></i>
                </div>
              </div>
              <el-table :data="brandRank" stripe height="400" class="border-DEDEDE"
                        :default-sort="{prop: 'simple', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center">
                </el-table-column>
                <el-table-column prop="name" label="品牌" align="center"></el-table-column>
                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'rankingList',
    data () {
      return {
        goodsTypeTab: 'currentSales',
        chooseType: '当期网络零售额',//当前选择查询条件
        allForm: {times: ''},//
        companyFrom: {platform: '全平台'},
        transactionForm: {platform: '全平台'},//交易平台筛选条件
        brandRankForm: {platform: '京东商城'},
        spuForm:{platform: '京东商城'},
        personalShopForm: {platform: '淘宝网'},
        companyRank: [],
        companyShopRank: [],
        personalShopRank: [],
        brandRank: [],
        spuRank: [],
        cityRank: [],
        item: [{value1: '全平台'}, {value2: '天猫商城'}, {value2: '淘宝网'}],
        transactionTime: '1',
        transactionTitle: '',

        regionDis: true,

        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    // http: {
    //   root: '/',
    //   headers: {
    //     token: sessionStorage.getItem("xybdsToken")
    //   }
    // },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.oneMonth()
      // this.oneMonth()
    },
    methods: {
      goodsTypeTabHandleClick (tab, event) {
        if (tab.name == 'cumulativeSales') {
          this.chooseType = '累计网络零售额'
          this.oneMonth()
        }
        if (tab.name == 'currentSales') {
          this.chooseType = '当期网络零售额'
          this.oneMonth()
        }

      },
      getAllRank () {
        this.getCityRank()
        this.getBrandRank()
        this.getCompanyShopRank()
        this.getPersonalShopRank()
        this.getSpuRank()
        this.getCompanyRank()
      },
      //下载
      down (type,platform) {
        // this.$router.push(this.header+'/qyjc/exportXlsx?'+'type='+type+'&index_type='+this.chooseType+'&times='+this.allForm.times+'&platform='+platform)
        window.open(this.header+'/qyjc/exportXlsx?'+'type='+type+'&index_type='+this.chooseType+'&times='+this.allForm.times+'&platform='+platform);
        // this.$http.get(this.header + '/qyjc/exportXlsx', {
        //   params: {
        //     type:type,
        //     index_type: this.chooseType,
        //     times: this.allForm.times,
        //     platform: this.companyFrom.platform
        //   }
        // }).then(res => {
        //   if (res.data.code == 0) {
        //     // this.companyRank = res.data.companyRank
        //   } else {
        //     +is.$alert(res.data.msg)
        //   }
        //
        // })
      },
      //获取企业榜
      getCompanyRank () {
        this.$http.get(this.header + '/qyjc/companyRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.companyFrom.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.companyRank = res.data.companyRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取企业店铺榜
      getCompanyShopRank () {
        this.$http.get(this.header + '/qyjc/companyShopRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.transactionForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.companyShopRank = res.data.companyShopRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取个人店铺榜
      getPersonalShopRank () {
        this.$http.get(this.header + '/qyjc/personalShopRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.personalShopForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.personalShopRank = res.data.personalShopRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取品牌榜
      getBrandRank () {
        this.$http.get(this.header + '/qyjc/brandRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.brandRankForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.brandRank = res.data.brandRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取单品榜
      getSpuRank () {
        this.$http.get(this.header + '/qyjc/spuRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.spuForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.spuRank = res.data.spuRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取地市榜
      getCityRank () {
        this.$http.get(this.header + '/qyjc/cityRank', {
          params: {
            index_type: this.chooseType,
            times: this.allForm.times,
            platform: this.transactionForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.cityRank = res.data.cityRank
          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.allForm.times = dataArr[1]
        } else {
          this.allForm.times = dataArr[2]
        }
        this.transactionTime = '1'
        this.getCityRank()
        this.getBrandRank()
        this.getCompanyShopRank()
        this.getPersonalShopRank()
        this.getSpuRank()
        this.getCompanyRank()
      },
    }
  }
</script>

<style>

  .rankingList-page {}

  .rankingList-page .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .rankingList-page .el-input--suffix .el-input__inner {
    padding-right: 30px;
    width: 120px;
  }

  .rankingList-page .el-card__header {
    height: 65px;
  }

  .rankingList-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .rankingList-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .rankingList-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 40px;
    margin-bottom: 0px;
  }

  .rankingList-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .rankingList-page .el-form-item {
    margin-bottom: 0;
  }

  .rankingList-page .el-radio, .rankingList-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/area/rankingList.vue